import DVCApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';

class DVCUserAPI extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCUsers';

  /**
   * Thực hiện đăng nhập vào dvc
   * dtnga3 (06.10.2022)
   */
  loginDVC(model) {
    let request = {
      url: [this.getAPIUrl(), 'login-dvc'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Thực hiện đăng xuất khỏi DVC
   * @param {*} param Bearer Token trả về khi đăng nhập
   * @returns
   * dtnga3 (10.10.2022)
   */
  logoutDVC(param) {
    let request = {
      url: [this.getAPIUrl(), 'logout-dvc'].join('/'),
      isCheckExpiredToken: false,
      data: { token: param },
    };
    return httpClient.postAsync(request);
  }
}

export default new DVCUserAPI();
